<template>
    <el-table
        :data="signInTable"
        ref="CNSignInTable"
        border
        :span-method="arraySpanMethod"
        :cell-style="rowStyle"
        class="performanceCNSignInTable"
        :height="height"
    >
        <el-table-column
            label="商品行号"
            prop="lineNo"
            show-overflow-tooltip
            align="center"
            width="100px"
        ></el-table-column>
        <el-table-column
            label="商品编码"
            prop="itemCode"
            align="center"
            show-overflow-tooltip
            width="150px"
        ></el-table-column>
        <el-table-column
            label="商品名称"
            prop="itemName"
            align="center"
            show-overflow-tooltip
            width="250px"
        ></el-table-column>
        <el-table-column
            label="商品状态"
            prop="itemStatusName"
            align="center"
            show-overflow-tooltip
            width="100px"
        ></el-table-column>
        <el-table-column
            label="发货"
            prop="realDeliverCount"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
        <el-table-column label="收货" show-overflow-tooltip align="center">
            <el-table-column
                label="正品签收"
                prop="goodSignQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.goodSignQty"
                        v-if="
                            signTableFieldIsEdit.goodSignQty &&
                            scope.$index !== signInTable.length - 1
                        "
                        @input="
                            computedNumberFromGoodSignQty(
                                scope.row,
                                'goodSignQty'
                            )
                        "
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>
                        {{ scope.row.goodSignQty }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="箱损签收"
                prop="packingdmgSignQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.packingdmgSignQty"
                        v-if="
                            signTableFieldIsEdit.packingdmgSignQty &&
                            scope.$index !== signInTable.length - 1
                        "
                        @input="computedNumber(scope.row, 'packingdmgSignQty')"
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>
                        {{ scope.row.packingdmgSignQty }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="机损签收"
                prop="machinedmgSignQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.machinedmgSignQty"
                        v-if="
                            signTableFieldIsEdit.machinedmgSignQty &&
                            scope.$index !== signInTable.length - 1
                        "
                        @input="computedNumber(scope.row, 'machinedmgSignQty')"
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>
                        {{ scope.row.machinedmgSignQty }}
                    </div>
                </template>
            </el-table-column>
        </el-table-column>

        <el-table-column label="拒收" show-overflow-tooltip align="center">
            <el-table-column
                label="正品拒收"
                prop="goodRejectQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.goodRejectQty"
                        v-if="
                            signTableFieldIsEdit.goodRejectQty &&
                            scope.$index !== signInTable.length - 1
                        "
                        @input="
                            computedNumberFromGoodRejectQty(
                                scope.row,
                                'goodRejectQty'
                            )
                        "
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>
                        {{ scope.row.goodRejectQty }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="箱损拒收"
                prop="packingdmgRejectQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.packingdmgRejectQty"
                        v-if="
                            signTableFieldIsEdit.packingdmgRejectQty &&
                            scope.$index !== signInTable.length - 1
                        "
                        @input="
                            computedNumber(scope.row, 'packingdmgRejectQty')
                        "
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>
                        {{ scope.row.packingdmgRejectQty }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="机损拒收"
                prop="machinedmgRejectQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.machinedmgRejectQty"
                        v-if="
                            signTableFieldIsEdit.machinedmgRejectQty &&
                            scope.$index !== signInTable.length - 1
                        "
                        @input="
                            computedNumber(scope.row, 'machinedmgRejectQty')
                        "
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>
                        {{ scope.row.machinedmgRejectQty }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="附件缺失拒收"
                prop="fittingshortRejectQty"
                show-overflow-tooltip
                align="center"
                width="105px"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.fittingshortRejectQty"
                        v-if="
                            signTableFieldIsEdit.fittingshortRejectQty &&
                            scope.$index !== signInTable.length - 1
                        "
                        @input="
                            computedNumber(scope.row, 'fittingshortRejectQty')
                        "
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>
                        {{ scope.row.fittingshortRejectQty }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="性能拒收"
                prop="performRejectQty"
                show-overflow-tooltip
                align="center"
            >
                <template slot-scope="scope">
                    <el-input
                        v-model.trim="scope.row.performRejectQty"
                        v-if="
                            signTableFieldIsEdit.performRejectQty &&
                            scope.$index !== signInTable.length - 1
                        "
                        @input="computedNumber(scope.row, 'performRejectQty')"
                        class="customTableColumnInput"
                    />
                    <div class="notEdit" v-else>
                        {{ scope.row.performRejectQty }}
                    </div>
                </template>
            </el-table-column>
        </el-table-column>

        <el-table-column
            label="短少"
            align="center"
            prop="shortQty"
            show-overflow-tooltip
        >
            <template slot-scope="scope">
                <el-input
                    v-model="scope.row.shortQty"
                    v-if="
                        signTableFieldIsEdit.shortQty &&
                        scope.$index !== signInTable.length - 1
                    "
                    @input="computedNumber(scope.row, 'shortQty')"
                    class="customTableColumnInput"
                />
                <div v-else>{{ scope.row.shortQty }}</div>
            </template>
        </el-table-column>

        <el-table-column
            label="备注"
            show-overflow-tooltip
            width="150px"
            align="center"
        >
            <template slot-scope="scope">
                <el-input
                    v-model.trim="scope.row.signRemark"
                    style="width: 100%"
                    class="customTableColumnInput"
                    v-if="
                        signTableFieldIsEdit.signRemark &&
                        scope.$index !== signInTable.length - 1
                    "
                ></el-input>
                <div v-else>{{ scope.row.signRemark }}</div>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import _ from 'lodash';
import { OPERATE_TYPE } from '../utils/constant.js';
import { sum, toNum,subtraction, numInputLimit, roundDecimalPlaces, CNTableFieldIsEdit } from './util.js';
export default {
    name: 'signInTable',
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        tableDataList: {
            type: Array,
            default () {
                return [];
            }
        },
        operateType: { // 操作类别
            type: String,
            default: ''
        },
        height: {
            type: Number,
            default: 320
        }
    },
    data () {
        return {
            signInTable: [],
            SignInTablePropObj: {},
            SignInTablePropArr: [],
            signTableFieldIsEdit: { // 定制化签收表格字段是否可编辑，默认都不可编辑
                goodSignQty: false,
                packingdmgSignQty: false,
                machinedmgSignQty: false,
                goodRejectQty: false,
                packingdmgRejectQty: false,
                machinedmgRejectQty: false,
                fittingshortRejectQty: false,
                performRejectQty: false,
                shortQty: false,
                signRemark: false
            }
        };
    },
    methods: {
        /**
         * @description 表格居中样式
         */
        rowStyle () {
            return 'text-align:center';
        },
        /**
         * @description: 合并单元格（根据展示情况不同，合并单元格调用的方法不同）
         * @param：row 当前行
         * @param：column 当前列
         * @param：rowIndex 当前行号
         * @param：columnIndex 当前列号
         * @return {*} 合并的单元格格式
         */
        arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
            // 判断是否为最后一行
            if (rowIndex === this.signInTable.length - 1) {
                if (columnIndex === 0) {
                    return [1, 4];
                } else if (columnIndex === 1) {
                    return [1, 1];
                } else if (columnIndex === 2) {
                    return [1, 3];
                } else if (columnIndex === 3) {
                    return [1, 5];
                } else if (columnIndex === 4 || columnIndex === 5) {
                    return [1, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        /**
         * @description 初始化回单签收表格数据
         */
        initTableData () {
            const copyTableDataList = JSON.parse(JSON.stringify(this.tableDataList));
            // const listData = this.initSignTableData(copyTableDataList); // 针对直通宝签收 初始化PC端拒收展示数值
            const lastTableDataList = this.signInTable.length ? this.signInTable[this.signInTable.length - 1] : {};
            this.signInTable = lastTableDataList.hasOwnProperty('isTotalRow') && lastTableDataList.isTotalRow // 判断是否已经添加过合计
                ? this.signInTable // 已经添加过，直接使用
                : this.pushLastTableList(copyTableDataList); // 未添加过,则将初始化后的数据 进行添加合计行 操作
        },
        /**
         * @description 初始化回单签收表格数据
         */
        initSignTableData () {
            const copyTableData = JSON.parse(JSON.stringify(this.tableDataList));
            // 签收时 正品签收数默认填充为发货数，其余默认为0
            if (this.operateType === OPERATE_TYPE.SIGN_COMFIRM) {
                this.signInTable.forEach(v => {
                    v.goodSignQty = v.realDeliverCount;
                    v.packingdmgSignQty = 0;
                    v.machinedmgSignQty = 0;
                    v.goodRejectQty = 0;
                    v.packingdmgRejectQty = 0;
                    v.machinedmgRejectQty = 0;
                    v.fittingshortRejectQty = 0;
                    v.performRejectQty = 0;
                    v.shortQty = 0;
                });
            }
            // 拒收时 正品拒收数默认填充为发货数，其余默认为0
            if (this.operateType === OPERATE_TYPE.REJECT_COMFIRM) {
                this.signInTable.forEach(v => {
                    v.goodSignQty = 0;
                    v.machinedmgSignQty = 0;
                    v.packingdmgSignQty = 0;
                    v.goodRejectQty = v.realDeliverCount;
                    v.packingdmgRejectQty = 0;
                    v.machinedmgRejectQty = 0;
                    v.fittingshortRejectQty = 0;
                    v.performRejectQty = 0;
                    v.shortQty = 0;
                });
            }
            this.$emit('setCount', copyTableData);
            return copyTableData;
        },

        /**
         * @description: 计算合计 加入到table最后一行
         * @param {Array} tableDataList 列表数据
         * @return {tableDataList} 加入合计后的数据
         */
        pushLastTableList (tableDataList) {
            // 动态获取table中的prop属性（判断是否存在子元素，如果存在则进行双重循环）
            this.$refs.CNSignInTable.$children.forEach(item => {
                if (item.label && item.label !== undefined && item.$children.length === 0) {
                    this.SignInTablePropObj[item.prop] = 0;
                    this.SignInTablePropArr.push(item.prop);
                } else if (item.label && item.label !== undefined && item.$children.length !== 0) {
                    item.$children.forEach((childrenItem) => {
                        this.SignInTablePropObj[childrenItem.prop] = 0;
                        this.SignInTablePropArr.push(childrenItem.prop);
                    });
                }
            });
            // 赋值总计行数据并插入到表单数据
            tableDataList.forEach(item => {
                const realDeliverCountTotal = sum([item.realDeliverCount]);
                const takeGoodsCountTotal = sum([
                    item.goodSignQty,
                    item.packingdmgSignQty,
                    item.machinedmgSignQty
                ]);
                const rejectGoodsCountTotal = sum([
                    item.goodRejectQty,
                    item.performRejectQty,
                    item.packingdmgRejectQty,
                    item.machinedmgRejectQty,
                    item.fittingshortRejectQty
                ]);
                const shortGoodsCountTotal = sum([item.shortQty]);
                this.SignInTablePropObj[this.SignInTablePropArr[0]] = '合 计 ：';
                this.SignInTablePropObj[this.SignInTablePropArr[1]] += realDeliverCountTotal; // 发货总计
                this.SignInTablePropObj[this.SignInTablePropArr[2]] += takeGoodsCountTotal; // 收货总计
                this.SignInTablePropObj[this.SignInTablePropArr[3]] += rejectGoodsCountTotal; // 拒收总计
                this.SignInTablePropObj[this.SignInTablePropArr[4]] += shortGoodsCountTotal; // 短少总计
                this.SignInTablePropObj[this.SignInTablePropArr[5]] = ''; // 备注总计
                this.SignInTablePropObj.isTotalRow = true; // 合计行标识
            });
            Object.keys(this.SignInTablePropObj).forEach(key => {
                this.SignInTablePropObj[key] = roundDecimalPlaces(this.SignInTablePropObj[key]);
            });
            tableDataList.push(this.SignInTablePropObj);
            return tableDataList;
        },
        /**
         * @description 修改后重新计算数值
         * @param {Object} row 当前操作行数据
         * @param {String} prop 当前操作目标字段
         */
        computedNumber (row, prop) {
            row[prop] = numInputLimit(row, prop);
            // 签收，重新计算正品签收数量
            // if (this.operateType === OPERATE_TYPE.SIGN_COMFIRM) {
            //     const noGoodsSignQty = sum([
            //         row.packingdmgSignQty,
            //         row.machinedmgSignQty,
            //         row.goodRejectQty,
            //         row.packingdmgRejectQty,
            //         row.machinedmgRejectQty,
            //         row.fittingshortRejectQty,
            //         row.performRejectQty,
            //         row.shortQty
            //     ]);
            //     row.goodSignQty = subtraction(toNum(row.realDeliverCount), noGoodsSignQty);
            // }

            // 拒收，重新计算正品拒收数量
            // if (this.operateType === OPERATE_TYPE.REJECT_COMFIRM) {
            //     const rejectCountTotal = sum([
            //         row.goodSignQty,
            //         row.packingdmgSignQty,
            //         row.machinedmgSignQty,
            //         row.packingdmgRejectQty,
            //         row.machinedmgRejectQty,
            //         row.fittingshortRejectQty,
            //         row.performRejectQty,
            //         row.shortQty
            //     ]);
            //     row.goodRejectQty = subtraction(toNum(row.realDeliverCount), rejectCountTotal);
            // }
            const setCountParam = this.isAfterPushData();
            this.computedSumUpNumber(setCountParam);
            this.$emit('setCount', setCountParam);
        },

        /**
         * @description 修改正品签收时触发的计算
         * @tip 注意：目前场景 在此页面 正品签收 是不可编辑的，即 该函数是不会触发的，只是为后期增加场景时，预留方法
         * @param {Object} row 当前操作行数据
         * @param {String} prop 当前操作目标字段
         */
        computedNumberFromGoodSignQty (row, prop) {
            row[prop] = numInputLimit(row, prop);
            const setCountParam = this.isAfterPushData();
            this.computedSumUpNumber(setCountParam);
            this.$emit('setCount', setCountParam);
        },

        /**
         * @description 修改正品拒收时触发的计算
         * @tip 注意：目前场景 在此页面 正品拒收 是不可编辑的，即 该函数是不会触发的，只是为后期增加场景时，预留方法
         * @param {Object} row 当前操作行数据
         * @param {String} prop 当前操作目标字段
         */
        computedNumberFromGoodRejectQty (row, prop) {
            row[prop] = numInputLimit(row, prop);
            const setCountParam = this.isAfterPushData();
            this.computedSumUpNumber(setCountParam);
            this.$emit('setCount', setCountParam);
        },

        /**
         * @description: 判断是否为插入总计行的数据，如果是 删除总计行
         * @return {newSignInTable} 返回处理后的数据
         */
        isAfterPushData () {
            const newSignInTable = JSON.parse(JSON.stringify(this.signInTable));
            if (this.signInTable[this.signInTable.length - 1].isTotalRow) {
                newSignInTable.pop();
            }
            return newSignInTable;
        },

        /**
         * @description: 重新计算总计的数值
         * @param {*} rawData 删除总计行的表单数据
         */
        computedSumUpNumber (rawData) {
            let takeGoodsSumCount = 0;
            let shortGoodsSumCount = 0;
            let rejectGoodsSumCount = 0;
            rawData.forEach(item => {
                const takeGoodsCountTotal = sum([
                    item.goodSignQty,
                    item.packingdmgSignQty,
                    item.machinedmgSignQty
                ]);
                const rejectGoodsCountTotal = sum([
                    item.goodRejectQty,
                    item.performRejectQty,
                    item.packingdmgRejectQty,
                    item.machinedmgRejectQty,
                    item.fittingshortRejectQty
                ]);
                const shortGoodsCountTotal = sum([item.shortQty]);
                takeGoodsSumCount += takeGoodsCountTotal;
                rejectGoodsSumCount += rejectGoodsCountTotal;
                shortGoodsSumCount += shortGoodsCountTotal;
            });
            this.signInTable[this.signInTable.length - 1][this.SignInTablePropArr[2]] = roundDecimalPlaces(takeGoodsSumCount);
            this.signInTable[this.signInTable.length - 1][this.SignInTablePropArr[3]] = roundDecimalPlaces(rejectGoodsSumCount);
            this.signInTable[this.signInTable.length - 1][this.SignInTablePropArr[4]] = roundDecimalPlaces(shortGoodsSumCount);
        },

        /**
         * @description 组装数据
         * @return {Array} 组装后的数据
         */
        formatReqParams () {
            const rawData = this.isAfterPushData();
            const params = rawData.map(v => {
                return {
                    id: v.id, // 商品id
                    receiptDetailId: v.id,
                    orderType: 0,
                    version: v.version || 0,
                    stockoutCount: v.shortQty || 0,
                    orderNo: this.rowData.taskNo,
                    signRemark: v.signRemark, // 备注
                    taskNo: this.rowData.taskNo, // 运输单号
                    upperLineNo: v.upperLineNo, // 上游商品行号
                    custItemCode: v.custItemCode, // 客户商品编码
                    itemCode: v.itemCode, // 商品编码
                    itemName: v.itemName, // 商品名称
                    itemStatus: v.itemStatus, // 商品状态
                    itemSuiteCode: v.itemSuiteCode, // 套机编码
                    lineNo: v.lineNo, // 商品行号
                    goodSignQty: v.goodSignQty || 0, // 正品签收数量
                    packingdmgSignQty: v.packingdmgSignQty || 0, // 箱损签收数量
                    machinedmgSignQty: v.machinedmgSignQty || 0, // 机损签收数量
                    shortQty: v.shortQty || 0, // 短少数量
                    goodRejectQty: v.goodRejectQty || 0, // 正品拒收数量
                    packingdmgRejectQty: v.packingdmgRejectQty || 0, // 箱损拒收数量
                    machinedmgRejectQty: v.machinedmgRejectQty || 0, // 机损拒收数量
                    fittingshortRejectQty: v.fittingshortRejectQty || 0, // 附件缺失拒收
                    performRejectQty: v.performRejectQty || 0, // 性能拒收
                    realDeliverCount: v.realDeliverCount || 0, // 实发数量
                    packageDamagedCount: sum([v.packingdmgSignQty, v.machinedmgSignQty, v.fittingshortSignQty]) || 0, // 破损数
                    rejectQty: sum([v.goodRejectQty, v.packingdmgRejectQty, v.machinedmgRejectQty, v.fittingshortRejectQty, v.performRejectQty]) || 0, // 拒收数
                    realReceiveCount: sum([v.goodSignQty, v.machinedmgSignQty, v.packingdmgSignQty, v.fittingshortSignQty]) || 0, // 实收数量
                    abnormalCount: subtraction(Number(v.realDeliverCount), Number(v.goodSignQty)) || 0, // 总异常数量
                    realReceive: v.goodSignQty || 0 // 正品数量
                };
            });
            return params;
        },

        validateDataIsTrue () {
            const rawData = this.isAfterPushData();
            const realDeliverCountIsTrue = rawData.every(v => {
                const realDeliverQty = sum([
                    v.shortQty,
                    v.goodSignQty,
                    v.goodRejectQty,
                    v.performRejectQty,
                    v.packingdmgSignQty,
                    v.machinedmgSignQty,
                    v.machinedmgRejectQty,
                    v.packingdmgRejectQty,
                    v.fittingshortRejectQty
                ]);
                return toNum(v.realDeliverCount) === realDeliverQty;
            });
            return new Promise((resolve, reject) => {
                const goodSignQtyFlag = rawData.every(v => // 签收、短少数值是否为0
                    +v.goodSignQty === 0 &&
                    +v.packingdmgSignQty === 0 &&
                    +v.machinedmgSignQty === 0
                );
                const goodRejectQtyFlag = rawData.every(v => // 拒收数值是否为0
                    +v.goodRejectQty === 0 &&
                    +v.packingdmgRejectQty === 0 &&
                    +v.machinedmgRejectQty === 0 &&
                    +v.fittingshortRejectQty === 0 &&
                    +v.performRejectQty === 0 &&
                    +v.shortQty === 0
                );
                if (!goodRejectQtyFlag && this.operateType === OPERATE_TYPE.SIGN_COMFIRM) {
                    return reject(new Error('签收时只允许编辑签收相关字段，若要操作拒收，请从拒收按钮进入操作'));
                }
                if (!goodSignQtyFlag && this.operateType === OPERATE_TYPE.REJECT_COMFIRM) {
                    return reject(new Error('拒收时只允许编辑拒收相关字段，若要操作签收，请从签收按钮进入操作'));
                }
                if (!realDeliverCountIsTrue) {
                    return reject(new Error('收货数、拒收数及短少数之和不等于发货数，请检查后重新提交！'));
                }
                resolve(this.formatReqParams());
            });
        }
    },

    mounted () {
        this.initTableData();
        // 对初始对象中的数值进行操作时，先拷贝，在赋值，避免数据污染
        const copyTableFieldIsEdit = _.cloneDeep(CNTableFieldIsEdit[this.operateType]);
        this.signTableFieldIsEdit = copyTableFieldIsEdit;
    },
    watch: {
        tableDataList: {
            handler (val) {
                this.initTableData();
            },
            deep: true
        }
    }

};
</script>
<style lang="less">
.performanceCNSignInTable {
    .customTableColumnInput {
        .el-input__inner {
            border-color: transparent;
            cursor: default;

            &:focus {
                border-color: #c3c7c7;
            }
        }
    }
    .el-input {
        vertical-align: middle;
    }
    .el-input__inner {
        text-align: center;
    }
    .notEdit {
        height: 28px;
        line-height: 28px;
    }
    .el-table__row:last-child {
        .cell {
            width: 100% !important;
        }
    }
}
</style>
